import { useState } from "react";
import { Row, Col, Input } from "reactstrap";
import DataTable from "react-data-table-component";
import { Button } from "react-bootstrap";
import { useDispatch } from "react-redux";

import { simpleDate, simpleTime } from "../../../utils/displayDate";
import { customTableStyles } from "../styles/table";
import ApproveModal from "./ApproveModal";
import SimpleModal from "../../../components/common/SimpleModal";
import UpdateAccountForm from "../../member/components/form/UpdateAccountForm";
import { setUpdateAccount } from "../../management/redux/managementSlice";
import {
  ChevronIcon,
  EditIcon,
  ProcessIcon,
} from "../../../constants/icon_path";
import LoadingTable from "../../../components/common/LoadingTable";

const WithdrawRequestListTable = ({ data, refetchRequestList, loading }) => {
  const dispatch = useDispatch();
  const [showModal, setShowModal] = useState(false);
  const handleCloseModal = () => setShowModal(false);
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const handleCloseUpdateModal = () => setShowUpdateModal(false);
  const [rowData, setRowData] = useState({});

  const handleProcess = (data) => {
    setRowData(data);
    setShowModal(true);
  };

  const handleEdit = (data) => {
    setShowUpdateModal(true);
    dispatch(setUpdateAccount(data));
  };

  const [searchValue, setSearchValue] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  // ** Function to handle filter
  const handleFilter = (e) => {
    const value = e.target.value;
    let updatedData = [];
    setSearchValue(value);

    if (value.length) {
      updatedData = data?.filter((item) => {
        const startsWith = item.transactionNo
          .toString()
          .startsWith(value.toString());
        const includes = item.transactionNo
          .toString()
          .includes(value.toString());

        if (startsWith) {
          return startsWith;
        } else if (!startsWith && includes) {
          return includes;
        } else return null;
      });

      setFilteredData(updatedData);
      setSearchValue(value);
    }
  };

  const columns = [
    {
      name: "ເລກທີ່",
      selector: (row) => row.transactionNo,
      center: true,
      sortable: true,
      className: "notolao",
    },
    {
      name: "ລະຫັດລູກຄ້າ",
      selector: (row) => row?.member?.memberId,
      center: true,
      sortable: true,
      className: "notolao",
    },
    {
      name: "ຊື່ລູກຄ້າ",
      selector: (row) => row?.member?.nickname,
      center: true,
      sortable: true,
    },
    {
      name: "ຈຳນວນເງິນ",
      selector: (row) => row.amount,
      sortable: true,
      center: true,
    },
    {
      name: "ວັນທີ່",
      sortable: true,
      center: true,
      cell: (row) => (
        <span>
          {simpleDate(row.createdAt)} {simpleTime(row.createdAt)}
        </span>
      ),
    },
    {
      name: "ເລກບັນຊີ",
      sortable: true,
      center: true,
      cell: (row) => (
        <span>
          {row?.member?.account?.accountNo}{" "}
          <EditIcon
            color="green"
            className="pointer"
            size={25}
            onClick={() =>
              handleEdit({
                memberId: row?.member.id,
                accountNo: row?.member?.account?.accountNo,
                accountName: row?.member?.account?.accountName,
                bankName: row?.member?.account?.bankName,
                updatedAccount: row?.member.updatedAccount,
              })
            }
          />{" "}
        </span>
      ),
    },
    {
      name: "ດຳເນີນການ",
      sortable: true,
      center: true,
      cell: (row) => (
        <Button
          className="btn-xs"
          variant="success"
          onClick={() => handleProcess(row)}
        >
          <ProcessIcon color="white" size={16} /> ດຳເນີນການ
        </Button>
      ),
    },
  ];

  return (
    <>
      <ApproveModal
        handleClose={handleCloseModal}
        show={showModal}
        data={rowData}
        refetchRequestList={refetchRequestList}
      />
      <SimpleModal
        show={showUpdateModal}
        handleClose={handleCloseUpdateModal}
        title="ແກ້ໄຂເລກບັນຊີ"
        size="lg"
      >
        <UpdateAccountForm handleClose={handleCloseUpdateModal} />
      </SimpleModal>
      <Row className="m-2">
        <Col md="12">
          <Input
            className="dataTable-filter form-control"
            type="text"
            value={searchValue}
            onChange={handleFilter}
            placeholder="ຄົ້ນຫາ"
          />
        </Col>
      </Row>
      <Row>
        <Col md="12">
          <DataTable
            noHeader
            pagination
            data={searchValue.length ? filteredData : data && data}
            columns={columns}
            className="react-dataTable"
            sortIcon={<ChevronIcon size={10} />}
            filteredData="true"
            customStyles={customTableStyles}
            paginationRowsPerPageOptions={[50, 100, 150, 200]}
            progressComponent={<LoadingTable />}
            progressPending={loading}
            paginationPerPage={50}
          />
        </Col>
      </Row>
    </>
  );
};

export default WithdrawRequestListTable;
